import React from 'react'
import { Space, Table, Tag } from 'antd';
const LineTable = () => {
  const columns = [
    {
      title: 'Time ',
      dataIndex: 'Time',
      key: 'Time',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Target Output',
      dataIndex: 'Target',
      key: 'Target',
    },
    {
      title: 'Actual Output',
      dataIndex: 'ActualOutput',
      key: 'ActualOutput',
    },
    {
      title: 'Difference',
      dataIndex: 'Difference',
      key: 'Difference',
    },
    {
      title: 'OEE',
      dataIndex: 'OEE',
      key: 'OEE',
    },


  ];
  const data = [
    {
      key: '1',
      Time: '2:00:pm - 3:00:pm',
      Target: 39,
      ActualOutput: 32,
      Difference: 7,
      OEE: 67.23,
    },
    {
      key: '2',
      Time: '3:00:pm - 4:00:pm',
      Target: 62,
      ActualOutput: 0,
      Difference: -64,
      OEE: 60.18,
    },
    {
      key: '3',
      Time: '4:00:pm - 5:00:pm',
      Target: 62,
      ActualOutput: 0,
      Difference: -64,
      OEE: 60.18,
    },
    {
      key: '4',
      Time: '6:00:pm - 7:00:pm',
      Target: 102,
      ActualOutput: 50,
      Difference: -52,
      OEE: 38.18,
    },
    {
      key: '5',
      Time: '7:00:pm - 8:00:pm',
      Target: 95,
      ActualOutput: 70,
      Difference: -15,
      OEE: 40.39,
    },
    {
      key: '6',
      Time: '8:00:pm - 9:00:pm',
      Target: 40,
      ActualOutput: 50,
      Difference: 10,
      OEE: 90.18,
    },
  ];
  return (
    <div>
      <Table columns={columns} dataSource={data} pagination={false} className="linepermonitor-table"/>
    </div>
  )
}

export default LineTable